import { render, staticRenderFns } from "./invoiceSimple.vue?vue&type=template&id=05cd6db1&scoped=true&"
import script from "./invoiceSimple.vue?vue&type=script&lang=js&"
export * from "./invoiceSimple.vue?vue&type=script&lang=js&"
import style0 from "./invoiceSimple.vue?vue&type=style&index=0&id=05cd6db1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd6db1",
  null
  
)

export default component.exports